// Tax Vuex

import state from './taxStates.js'
import * as getters from './taxGetters.js'
import * as mutations from './taxMutations.js'
import * as actions from './taxActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
